<template>

  <m-pay-layout>
    <v-layout :column="$vuetify.breakpoint.smAndDown">
      <v-flex>
        <v-card class="mb-3 mx-2" max-width="700px">
          <m-pay-merchant-employee-editor
            :loading="loading"
            @cancel="cancel"
            @submit="addMerchantEmployee"
          />
        </v-card>
      </v-flex>
    </v-layout>
  </m-pay-layout>

</template>

<script>
import axios from 'axios';
import queries from '../../utils/queries';
import MPayMerchantEmployeeEditor from './MPayMerchantEmployeeEditor';


export default {
  name: 'MPayMerchantEmployeeCreateView',

  components: {
    MPayMerchantEmployeeEditor,
  },

  data: () => ({
    loading: false,
  }),

  methods: {
    cancel() {
      this.$router.go(-1);
    },
    addMerchantEmployee(user) {
      this.loading = true;
      axios.post(queries.merchantEmployee(), user)
        .then(() => {
          this.loading = false;
          this.$router.push({ name: 'merchant-employees' });
        })
        .catch((e) => {
          this.handleError(e);
        });
    },
    handleError(e) {
      this.showError(e);
      this.loading = false;
    },
  },

};
</script>



// WEBPACK FOOTER //
// src/components/merchant/MPayMerchantEmployeeCreateView.vue